export enum usertype_permissions {
  Admin = "UserType.Admin",
  AffiliatePresident = "UserType.AffiliatePresident",
  BackOffice = "UserType.BackOffice",
  Member = "UserType.Member",
  StateFed = "UserType.StateFed",
  Visitor = "UserType.Visitor",
  AffiliateStaff = "UserType.AffiliateStaff",
  Designee = "UserType.Designee"
}

export enum credential_permissions {
  Admin = "Credential.Admin",
  Assign = "Credential.Assign"
}
